import { IRest } from './rest.interface';
import { EnumPlanStatusType } from './enums/plan-status-type.enum';

export class TopicLink implements IRest {
    className = 'Link do Tópico';

    id!: number;
    planId!: number;
    topicId!: number;
    title!: string;
    url!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            planId: this.planId,
            topicId: this.topicId,
            title: this.title,
            url: this.url
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.planId = data['planId'] || 0;
            this.topicId = data['topicId'] || 0;
            this.title = data['title'] || '';
            this.url = data['url'] || '';
            if (this.url && !(this.url.includes('http://') || this.url.includes('https://'))) { this.url = ('https://' + this.url); }
        }
        return this;
    }

}

export class Topic implements IRest {
    className = 'Tópico';

    id!: number;
    name!: string;
    order!: number;
    finished!: boolean;
    announcementInitials!: string; //Uso Interno
    subtopics!: Array<Subtopic>; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            order: this.order,
            finished: this.finished
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.order = data['order'] || 0;
            this.finished = data['finished'] || false;
        }
        return this;
    }

}

export class PlanTopicStats implements IRest {
    className = 'Estastísticas do Tópico no Relacionamento com o Plano';

    questionsHit!: number;
    questionsMiss!: number;
    questionsPercentage!: number; //Uso Interno
    lastStudyId!: number;
    lastStudyDate!: Date;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            questionsHit: this.questionsHit,
            questionsMiss: this.questionsMiss,
            lastStudyId: this.lastStudyId,
            lastStudyDate: this.lastStudyDate.toISOString()
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.questionsHit = data['questionsHit'] || 0;
            this.questionsMiss = data['questionsMiss'] || 0;
            this.questionsPercentage = Math.round(this.questionsHit / ((this.questionsHit + this.questionsMiss) || 1) * 100);
            this.lastStudyId = data['lastStudyId'] || 0;
            this.lastStudyDate = data['lastStudyDate'] ? new Date(data['lastStudyDate']) : new Date(2000, 0);
        }
        return this;
    }

}

export class PlanTopicStatus implements IRest {
    className = 'Status do Tópico no Relacionamento com o Plano';

    type!: EnumPlanStatusType;
    date!: Date;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            type: this.type,
            date: this.date.toISOString()
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.type = data['type'] || EnumPlanStatusType.NotInit;
            this.date = data['date'] ? new Date(data['date']) : new Date(2000, 0);
        }
        return this;
    }

}

export class PlanTopic implements IRest {
    className = 'Relacionamento entre Plano e Disciplina/Tópico';

    id!: number;
    name!: string;
    jobIds!: Array<number>;
    announcementInitials?: string; //Uso Interno
    order!: number;
    finished!: boolean;
    stats!: PlanTopicStats;
    status!: PlanTopicStatus;
    links!: Array<TopicLink>; //Uso Interno
    linksCount!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            topicId: this.id || undefined,
            name: this.name,
            jobIds: this.jobIds,
            order: this.order,
            finished: this.finished,
            stats: this.stats.Serialize(),
            status: this.status.Serialize(),
            linksCount: this.linksCount

        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || data['topicId'] || 0;
            this.name = data['name'] || '';
            this.jobIds = data['jobIds'] || [];
            this.order = data['order'] || 0;
            this.finished = data['finished'] || false;
            this.stats = new PlanTopicStats(data['stats'] || {});
            this.status = new PlanTopicStatus(data['status'] || {});
            this.links = (data['links'] || []).map((l: any) => new TopicLink(l));
            this.linksCount = data['linksCount'] || 0;
        }
        return this;
    }

}

export class BatchTopic implements IRest {
    className = 'Lote de Tópicos a criar';

    topics!: Array<string>;
    topicCreated!: PlanTopic;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            topics: this.topics
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.topics = data['topics'] || [];
            if (data['topicId']) this.topicCreated = new PlanTopic(data);
        }
        return this;
    }

}

export class Subtopic implements IRest {
    className = 'Subtópico';

    id!: number;
    name!: string;
    announcementInitials!: string; //Uso Interno
    themeId!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            themeId: this.themeId || undefined
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.themeId = data['themeId'] || '';
        }
        return this;
    }

}